<template>
  <div class="mall-group-item">
    <div class="mall-group-item-label"
         @click="toggleExpand(group)">
      <span class="icon">
        <Icon type="md-arrow-dropright"
              v-if="canExpand"
              :class="expand ? 'expand' : ''" />
        <Icon type="ios-grid-outline"
              v-else />
      </span>
      <img :src="group.image" />
      <div class="name">{{ group.name || $t('pages_mall_groups_group_item_597') }}</div>
      <div class="handlers">
        <i-button @click.stop="onRemoveGroup(group)"
                  type="text">{{$t('libs_table_render_70')}}</i-button>
        <i-button @click.stop="onEditGroup(group)"
                  type="text">{{$t('pages_deduct_coupon_rule_components_scopeofuse_index_449')}}</i-button>
        <template v-if="level === 1">
          <i-button type="text"
                    @click.stop="addSubgroup">{{$t('pages_mall_groups_group_item_598')}}</i-button>
        </template>
        <template v-if="level === 2">
          <i-button type="text"
                    @click.stop="addProducts">{{$t('pages_mall_groups_group_item_599')}}</i-button>
        </template>
      </div>
    </div>
    <div class="child-groups"
         v-if="canExpand && expand">
      <group-item v-for="(item, index) in subgroups"
                  :index="index"
                  :level="level+1"
                  :group="item"
                  :expand-items="expandItems"
                  @addProducts="onAddProducts"
                  @removeProduct="removeProduct"
                  @expand="toggleExpand"
                  @removeGroup="onRemoveGroup"
                  @editGroup="onEditGroup"
                  :key="item.name" />
    </div>
    <div class="product-list"
         v-if="canExpand && expand">
      <div v-for="item in products"
           :key="item.id"
           class="product-list-item">
        <div class="img">
          <img :src="item.image"
               v-if="item.image" />
          <div v-else
               class="no-pic">{{$t('pages_mall_groups_group_item_600')}}</div>
        </div>
        <div>{{ item.name }}</div>
        <div class="handlers">
          <i-button type="text"
                    @click="removeProduct(item, group)">{{$t('pages_mall_groups_group_item_601')}}</i-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../locales/index'

export default {
  props: ['group', 'expandItems', 'level', 'index'],
  name: 'GroupItem',
  computed: {
    canExpand () {
      const { children = [], fresh_products = [] } = this.group || {};
      return (children.length > 0) || (fresh_products.length > 0);
    },
    subgroups () {
      const { children = [] } = this.group || {};
      return children;
    },
    products () {
      const { fresh_products = [] } = this.group || {};
      return fresh_products;
    },
    expand () {
      return this.expandItems && this.expandItems.includes(this.group.id)
    },
  },
  methods: {
    toggleExpand (group) {
      this.$emit('expand', group);
    },
    addSubgroup () {
      this.$emit('addGroup', this.group)
    },
    addProducts () {
      this.$emit('addProducts', this.group);
    },
    onAddProducts (group) {
      this.$emit('addProducts', group);
    },
    removeProduct (product, group) {
      this.$emit('removeProduct', product, group)
    },
    onRemoveGroup (group) {
      this.$emit('removeGroup', group);
    },
    onEditGroup (group) {
      this.$emit('editGroup', group)
    }
  }
}
</script>

<style lang="scss" scoped>
.mall-group-item {
  cursor: pointer;
  border-left: 24px solid #dff3ff;
  margin-left: 1px;
  border-bottom: 1px solid rgb(236, 236, 236);
  &:nth-of-type(2) {
    .mall-group-item-label {
      border-top: 1px solid rgb(236, 236, 236);
    }
  }
  &-label {
    height: 60px;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    font-weight: bold;
    color: #666;
    &:hover {
      background: rgb(96, 176, 251);
      color: #fff;
    }
    img {
      flex: 0 0 auto;
      margin-right: 8px;
      height: 40px;
    }
    .icon {
      flex: 0 0 auto;
      width: 16px;
    }
    .name {
      flex: auto;
    }
    .expand {
      transform: rotate(90deg);
    }
    .handlers {
      flex: 0 0 auto;
    }
  }
}
.child-groups {
  transition: all 0.3s ease;
}

.product-list {
  margin-bottom: -1px;
  &-item {
    padding-left: 10px;
    border-left: 24px solid #f5f5f5;
    margin-left: 1px;
    height: 40px;
    line-height: 40px;
    font-size: 13px;
    display: flex;
    align-items: center;
    padding-right: 12px;
    transition: all 0.3s ease;
    border-bottom: 1px solid rgb(240, 239, 239);
    &:hover {
      background: #e2e2e2;
    }
    > div {
      flex: auto;
    }
    > .handlers {
      flex: 0 0 auto;
    }

    &:nth-of-type(1) {
      border-top: 1px solid rgb(236, 236, 236);
    }
    .img {
      flex: 0 0 auto;
      margin-right: 12px;
      > img,
      > div {
        vertical-align: middle;
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>
